import booleanValid from '@turf/boolean-valid'
import parse from 'html-react-parser'

export const parseString = (input: unknown) =>
  typeof input === 'string' ? input : undefined

export const parseNumber = (input: unknown) =>
  typeof input === 'number' ? input : undefined

/** JSON numbers or numeric strings; rejects NaN/Infinity. */
export const parseFiniteNumber = (input: unknown) => {
  if (typeof input === 'number' && Number.isFinite(input)) {
    return input
  }
  if (typeof input === 'string' && input.trim() !== '') {
    const parsed = Number(input)
    if (Number.isFinite(parsed)) {
      return parsed
    }
  }
  return undefined
}

export const parseBoolean = (input: unknown) =>
  typeof input === 'boolean' ? input : undefined

export const parseDate = (input: unknown) => {
  if (typeof input !== 'string') {
    return undefined
  }
  const date = new Date(input)
  if (isNaN(date.getTime())) {
    return undefined
  }
  return date
}

export const parseDateAndSetToEST = (input: unknown) => {
  if (typeof input !== 'string') {
    return undefined
  }
  // Create date string with explicit EST timezone
  const estDateString = `${input}T00:00:00-05:00`
  const date = new Date(estDateString)
  if (isNaN(date.getTime())) {
    return undefined
  }
  return date
}

export const parseArray = <T>(input: unknown) =>
  !Array.isArray(input) ? undefined : (input as T[])

export const parseGeoJsonGeometry = (input: unknown) => {
  let result = input as GeoJSON.Geometry | undefined
  if (!!result && !booleanValid(result)) result = undefined
  return result
}

export const parseEnum = <T extends Record<string, string | number>>(
  enumObj: T,
  input: unknown
): T[keyof T] | undefined => {
  if (typeof input !== 'string') {
    return undefined
  }
  return Object.values(enumObj).includes(input)
    ? (input as T[keyof T])
    : undefined
}

export const parseToReactElement = (input: string): React.ReactNode => {
  try {
    const reactElement = parse(input.trim())
    return reactElement
  } catch {
    return input
  }
}
